




















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateBusinessHoursRequest from '@/models/BusinessHours/CreateBusinessHoursRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import AgencyUserStatus from '@/models/AgencyUsers/AgencyUserStatus';

@Component({
    name: 'BusinessHoursCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new CreateBusinessHoursRequest();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CreateBusinessHoursRequest();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }


  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }

    //Remove all the colons from the times
    // this.entity.monOpenAt = this.entity.monOpenAt.replaceAll(":", "");
    // this.entity.monCloseAt = this.entity.monCloseAt.replaceAll(":", "");
    // this.entity.tueOpenAt = this.entity.tueOpenAt.replaceAll(":", "");
    // this.entity.tueCloseAt = this.entity.tueCloseAt.replaceAll(":", "");
    // this.entity.wedOpenAt = this.entity.wedOpenAt.replaceAll(":", "");
    // this.entity.wedCloseAt = this.entity.wedCloseAt.replaceAll(":", "");
    // this.entity.thuOpenAt = this.entity.thuOpenAt.replaceAll(":", "");
    // this.entity.thuCloseAt = this.entity.thuCloseAt.replaceAll(":", "");
    // this.entity.friOpenAt = this.entity.friOpenAt.replaceAll(":", "");
    // this.entity.friCloseAt = this.entity.friCloseAt.replaceAll(":", "");
    // this.entity.satOpenAt = this.entity.satOpenAt.replaceAll(":", "");
    // this.entity.satCloseAt = this.entity.satCloseAt.replaceAll(":", "");
    // this.entity.sunOpenAt = this.entity.sunOpenAt.replaceAll(":", "");
    // this.entity.sunCloseAt = this.entity.sunCloseAt.replaceAll(":", "");

    await AgencySettingsModule.createBusinessHours(this.entity)
    this.dialog = false;
  }
}
